import classNames from 'classnames';

import s from './styles.module.scss';

import type { FC, ReactNode } from 'react';

interface ItemWrapperProps {
  label: string;
  children: ReactNode;
  location?: 'top' | 'left';
}

const ItemWrapper: FC<ItemWrapperProps> = ({
  label,
  children,
  location = 'top',
}) => {
  return (
    <div className={s.wrapper}>
      <label
        className={classNames(s.label, location === 'left' ? s.left : s.top)}
        data-cy={`dashboard-filter-${label}`}
      >
        <span className={s.text}>{label}</span>
        {children}
      </label>
    </div>
  );
};

export default ItemWrapper;
